import { Component, OnInit, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddleavepolicydetailComponent } from '../addleavepolicydetail/addleavepolicydetail.component';
import { DatePipe } from '@angular/common';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';

@Component({
  selector: 'app-addleavepolicy',
  templateUrl: './addleavepolicy.component.html',
  styleUrls: ['./addleavepolicy.component.css']
})
export class AddleavepolicyComponent implements OnInit, AfterViewInit {

  @ViewChildren('input') firstipcontrol;

  formname: String = "LeavePolicy";

  //Display
  formmode: string = "Add";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;
  //Edit Get Values
  leavepolicyColl: any = [];
  leavepolicyBO: any = {};

  leavepolicyid: number = 0;

  leavepolicydetailsColl: any = [];





  leavepolicyform = new FormGroup({
    leavepolicyid: new FormControl(0),
    leavepolicyname: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });



  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal, private datePipe: DatePipe,
    private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.leavepolicyid = params.id
      }
    });

    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.leavepolicyform.reset();
      this.fnInitializeFormGroup();

      if (this.leavepolicyid > 0) {
        this.fngetLeavePolicy();
      }


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.leavepolicyid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  ngAfterViewInit()
  {
    this.loginService.fnSetFirstControlFocus('txtfirst');
  }
  fnInitializeFormGroup() {
    this.leavepolicyform.setValue({
      leavepolicyid: 0,
      leavepolicyname: '',
      inactive: false
    })
  }

  //Get 
  fngetLeavePolicy() {
    if (this.showProgress) {
      return;
    }
    var data = {
      'leavepolicyid': this.leavepolicyid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getLeavePolicy(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();

            this.leavepolicyColl = res.json().result[0];
            var editdata = this.leavepolicyColl[0];
            this.fnEditMode(editdata);
            this.leavepolicyBO = editdata;

            this.leavepolicydetailsColl = res.json().result[1];

            console.log(res.json().result)
          }
          else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }



  //Save Btn Click
  fnSaveBtnClick() {
    try { if (this.saveloading) {
      return;
    }


      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.leavepolicyform.valid) { this.saveloading = true;

        //Check
        var data = {
          'leavepolicyid': this.leavepolicyid,
          'leavepolicyname': this.leavepolicyform.get('leavepolicyname').value,
          'inactive': this.leavepolicyform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
          'leavepolicydetailscoll': this.leavepolicydetailsColl
        }


        this.appService.fnCheckLeavePolicy(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var _checkresult = res.json().result[0].checkfield;

              if (_checkresult === "done") {
                if (this.leavepolicyform.get('leavepolicyid').value > 0) {
                  //Update 
                  this.fnSetLeavePolicy(data);
                }
                else {
                  //Insert 
                  this.fnInsertLeavePolicy(data);
                }
              }
              else {
                if (_checkresult === "name") { this.saveloading = false;
                  this.leavepolicyform.controls['leavepolicyname'].setErrors({ 'notfound': true });
                }
              }
            }
            else { this.saveloading = false;
              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => { this.saveloading = false;
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) { this.saveloading = false;
      this.fnShowErrorMsg(ex);
    }
  }




  //Insert
  fnInsertLeavePolicy(data) {

    this.appService.fnInsertLeavePolicy(data).subscribe(
      (res) => { this.saveloading = false;
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The new leavepolicy has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, data.leavepolicyname);

            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => { this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetLeavePolicy(data) {

    this.appService.fnSetLeavePolicy(data).subscribe(
      (res) => { this.saveloading = false;
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The leavepolicy has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.leavepolicyid, data.leavepolicyname);

            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => { this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  //Close
  fnCloseForm() {
    try {
      this.router.navigate(['/LeavePolicy']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }




  //Grid

  fnAddLevepolicyDetails() {

    const modalRef = this.productFindService.open(AddleavepolicydetailComponent, { size: <any>'l' });

    modalRef.componentInstance.leavepolicydetailsColl = this.leavepolicydetailsColl;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      this.leavepolicydetailsColl.push(receivedEntry);

    });
  }

  fnEditLevepolicyDetails(index) {


    const modalRef = this.productFindService.open(AddleavepolicydetailComponent, { size: <any>'l' });

    var data = this.leavepolicydetailsColl[index];

    modalRef.componentInstance.leavepolicydetid = data.leavepolicydetid;
    modalRef.componentInstance.leavetypeid = data.leavetypeid;
    modalRef.componentInstance.noofleave = data.noofleave;
    modalRef.componentInstance.iscarry = data.iscarry;
    modalRef.componentInstance.accurualperiod = data.accurualperiod;
    modalRef.componentInstance.accurualperiodtype = data.accurualperiodtype;
    modalRef.componentInstance.accurualperiodmonth = data.accurualperiodmonth;
    modalRef.componentInstance.maxleaveencashdays = data.maxleaveencashdays;
    modalRef.componentInstance.leaveoverflow = data.leaveoverflow;
    modalRef.componentInstance.isholidaybetweenleave = data.isholidaybetweenleave;
    modalRef.componentInstance.isweekendbetweenleave = data.isweekendbetweenleave;
    modalRef.componentInstance.leavepolicydetailsColl = this.leavepolicydetailsColl;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {


      this.leavepolicydetailsColl[index].leavepolicydetid = receivedEntry.leavepolicydetid;
      this.leavepolicydetailsColl[index].leavetypeid = receivedEntry.leavetypeid;
      this.leavepolicydetailsColl[index].leavetypename = receivedEntry.leavetypename;
      this.leavepolicydetailsColl[index].noofleave = receivedEntry.noofleave;
      this.leavepolicydetailsColl[index].iscarry = receivedEntry.iscarry;
      this.leavepolicydetailsColl[index].accurualperiodaccurualperiodtype = receivedEntry.accurualperiodaccurualperiodtype;
      this.leavepolicydetailsColl[index].accurualperiodtype = receivedEntry.accurualperiodtype;
      this.leavepolicydetailsColl[index].accurualperiodmonth = receivedEntry.accurualperiodmonth;
      this.leavepolicydetailsColl[index].maxleaveencashdays = receivedEntry.maxleaveencashdays;
      this.leavepolicydetailsColl[index].leaveoverflow = receivedEntry.leaveoverflow;
      this.leavepolicydetailsColl[index].isholidaybetweenleave = receivedEntry.isholidaybetweenleave;
      this.leavepolicydetailsColl[index].isweekendbetweenleave = receivedEntry.isweekendbetweenleave;




    });

  }

  fnDeleteLeavepolicyConfirm(index) {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete details?')
        .then((confirmed) => {
          if (confirmed) {
            this.leavepolicydetailsColl.splice(index, 1)
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnDeleteLeavepolicyDetails(index) {



  }




  private fnEditMode(deptBO) {
    this.leavepolicyform.setValue({
      leavepolicyid: deptBO.leavepolicyid,
      leavepolicyname: deptBO.leavepolicyname,
      inactive: deptBO.inactive
    });

    this.formmode = "Edit";

    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }

  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }


  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }
  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }






}
